import { SHOW_DELETE_STORE_MODAL, DELETE_STORE } from './actionTypes';

export const showDeleteModalStore = (data) => ({
  type: SHOW_DELETE_STORE_MODAL,
  data,
});

export const deleteStore = (data) => ({
  type: DELETE_STORE,
  data,
});
